import React, { useState, useMemo, useCallback } from 'react';
import './common-header.scss';
import { Button } from 'react-bootstrap';
import { debounce } from 'lodash';

interface ICommonHeaderProps {
    pageTitle: string;
    pageSubtitle?: string;
    searchValue?: string;
    handleSearchChange?: (value: string) => void;
    actionButtons?: React.ReactNode;
}

const CommonHeader: React.FC<ICommonHeaderProps> = (props: ICommonHeaderProps) => {
    const { pageTitle, pageSubtitle, searchValue, handleSearchChange, actionButtons } = props;
    const [localSearchText, setLocalSearchText] = useState(searchValue ?? "");

    // Create a debounced version of the search handler
    const debouncedSearch = useMemo(
        () => debounce((value: string) => {
            handleSearchChange?.(value);
        }, 500),
        [handleSearchChange]
    );

    // Handle search input change
    const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setLocalSearchText(value);
        debouncedSearch(value);
    }, [debouncedSearch]);

    // Handle clear button
    const handleClear = useCallback(() => {
        setLocalSearchText("");
        handleSearchChange?.("");
    }, [handleSearchChange]);

    return (
        <div className="common-header-main">
            <div className="page-title-main">
                <h2 dangerouslySetInnerHTML={{ __html: pageTitle }}></h2>
                {pageSubtitle && (<p dangerouslySetInnerHTML={{ __html: pageSubtitle }}></p>)}
            </div>
            <div className="search-bar-main">
                <div className='search-form'>
                    <input
                        type="text"
                        min={0}
                        className="form-control"
                        placeholder="Search"
                        onChange={handleInputChange}
                        value={localSearchText}
                    />
                    <Button
                        type="button"
                        variant="outline-secondary"
                        className="btn btn-secondary btn-search"
                        onClick={handleClear}
                    >
                        Clear
                    </Button>
                </div>
            </div>
            <div className='header-actions'>
                {actionButtons && (actionButtons)}
            </div>
        </div>
    )
}

export default CommonHeader;